<template>
  <a-tabs>
   <a-tab-pane key="1" tab="功能模块">
      <features v-on:select="select" />
   </a-tab-pane>
    <!-- <a-tab-pane key="3" tab="商品链接">
  <selectGood  v-on:select="selectGoods" :selectList='goodList' :checkout="false"/>
   </a-tab-pane> -->
   <a-tab-pane key="4" tab="自定义链接">
      <customize v-on:success="selectTools" />
   </a-tab-pane>
  </a-tabs>
</template>
<script>
import { reactive, toRefs } from '@vue/reactivity'
import customize from './components/customize'
import features from './components/features'
// import pagesLinks from './components/pagesLinks'

export default {
  name:'untilSelect',
  components:{features,customize},
  setup(props,{emit}){
    const state=reactive({
      goodList:[]
    })
    const select=(data)=>{
        emit('success',data)
    }
    const selectGoods=(data)=>{
       state.goodList = data
        emit('success',{
          key:'store',
          link:'/pages/goods_details/index?id='+data.id
        })
    }
    const selectTools=(url)=>{
        emit('success',  {
          key:'customize',
          link:url
        })
    }
  
    return{
      selectGoods,
      select,
      selectTools,
      ...toRefs(state)
    }
  }
}
</script>